import {
    buildFooterSocialItems,
    buildWhatsappHref,
} from '@/components/welcome/landing/landing-footer-data';

const DEFAULT_CUSTOM_LINKS = [
    {
        id: 'whatsapp-channel',
        label: 'قناة واتساب الرسمية',
        subtitle: 'آخر الأخبار والتحديثات على واتساب',
        url: 'https://whatsapp.com/channel/0029Vb6z3DX3wtb8iKfkA21K',
        color: '#25D366',
        brand: 'whatsapp',
    },
    {
        id: 'telegram-channel',
        label: 'قناة تليجرام',
        subtitle: 'تابعنا يوميًا على تليجرام',
        url: 'https://t.me/codingwithghonaim',
        color: '#26A5E4',
        brand: 'telegram',
    },
    {
        id: 'ios-app',
        label: 'تطبيق iOS',
        subtitle: 'حمّل تطبيق Coding With Ghonaim من App Store',
        url: 'https://apps.apple.com/eg/app/codingwithghonaim/id6778895200',
        color: '#111111',
        brand: 'apple',
    },
    {
        id: 'android-app',
        label: 'تطبيق Android',
        subtitle: 'حمّل تطبيق Coding With Ghonaim من Google Play',
        url: 'https://play.google.com/store/apps/details?id=com.codingwithghonaim.app',
        color: '#01875f',
        brand: 'android',
    },
    {
        id: 'facebook-group',
        label: 'جروب فيسبوك الرسمي',
        subtitle: 'انضم لجروب البرمجة مع غنيم على فيسبوك',
        url: 'https://facebook.com/groups/codingwithghonaim',
        color: '#1877F2',
        brand: 'facebook',
    },
    {
        id: 'ali-gpt',
        label: 'علي — مساعدك في المذاكرة',
        subtitle: 'GPT مخصص لمساعدة طلاب الثانوية في الدراسة والمراجعة',
        url: 'https://chatgpt.com/g/g-68e3733053dc81919f03db6b7e984d39-ly-khwk-lkbyr-fy-lthnwy',
        color: '#10a37f',
    },
];

const CARD_PALETTES = [
    {
        bg: 'linear-gradient(135deg, #e33434 0%, #f26b5a 100%)',
        glow: '0 8px 24px rgba(227, 52, 52, 0.35)',
    },
    {
        bg: 'linear-gradient(135deg, #00235b 0%, #1a4a8a 100%)',
        glow: '0 8px 24px rgba(0, 35, 91, 0.35)',
    },
    {
        bg: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
        glow: '0 8px 24px rgba(124, 58, 237, 0.35)',
    },
    {
        bg: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)',
        glow: '0 8px 24px rgba(13, 148, 136, 0.35)',
    },
];

function extractLinksArray(source) {
    if (!source) {
        return [];
    }

    if (Array.isArray(source)) {
        return source;
    }

    if (Array.isArray(source.data)) {
        return source.data;
    }

    if (Array.isArray(source.links)) {
        return source.links;
    }

    return [];
}

export function buildLinksPageSocialItems(appData) {
    const items = buildFooterSocialItems(appData);
    const whatsappHref = buildWhatsappHref(appData);

    if (whatsappHref && appData && appData.whatsapp_url) {
        items.push({
            brand: 'whatsapp',
            label: 'WhatsApp',
            color: '#25D366',
            href: whatsappHref,
        });
    }

    return items;
}

export function normalizeCustomLinkCards(rawLinks) {
    const links = extractLinksArray(rawLinks);

    return links
        .filter((link) => link && (link.url || link.href))
        .map((link, index) => {
            const palette = CARD_PALETTES[index % CARD_PALETTES.length];
            const color = link.color || link.bg_color || null;

            return {
                id: link.id || `link-${index}`,
                label: link.title || link.name || link.label || 'رابط',
                subtitle: link.subtitle || link.description || link.content || '',
                url: link.url || link.href,
                image_url: link.image_url || link.image || null,
                brand: link.brand || null,
                bg: color
                    ? `linear-gradient(135deg, ${color} 0%, ${color} 100%)`
                    : palette.bg,
                glow: palette.glow,
            };
        });
}

export function getCustomLinksFromAppData(appData) {
    if (!appData) {
        return [];
    }

    const candidates = [
        appData.links,
        appData.app_links,
        appData.link_items,
        appData.official_links,
        appData.custom_links,
    ];

    for (let i = 0; i < candidates.length; i += 1) {
        const normalized = normalizeCustomLinkCards(candidates[i]);
        if (normalized.length) {
            return normalized;
        }
    }

    return [];
}

export function mergeCustomLinkCards(...groups) {
    const seen = new Set();
    const merged = [];

    groups.flat().forEach((link) => {
        if (!link || !link.url || seen.has(link.url)) {
            return;
        }
        seen.add(link.url);
        merged.push(link);
    });

    return merged;
}

export function getCustomLinkCards(appData, extraLinks = []) {
    const defaults = normalizeCustomLinkCards(DEFAULT_CUSTOM_LINKS);
    const backend = getCustomLinksFromAppData(appData);
    return mergeCustomLinkCards(defaults, backend, extraLinks);
}
